import React from 'react';
import Button from './common/Button';

// Fixed (not FIU-brand-driven) so Terms/Privacy links stay visually
// distinguishable as links regardless of the configured primaryBtnColor.
const LINK_COLOR = '#273C89';

const LoginForm = ({
	customDetails,
	mobileNumber,
	AAHandle,
	sendSpinner,
	isGetOTPDisabled,
	mobileError,
	aaHandleError,
	onMobileNumberChange,
	onAAHandleChange,
	onSendOtp,
	onToggleSheet,
	onTogglePrivacySheet,
}) => {
	return (
		<div className="container px-3">
			<div className="row mb-3">
				<div>
					<div className="row">
						<div className="col-lg-12 col-12">
							<h1
								className="fs-12 fw-600 text-start"
								style={{
									color: customDetails?.headingColor,
									fontFamily: customDetails?.fontFamily,
									textAlign: 'left',
									fontSize: customDetails?.fontSize,
								}}
							>
								MANAGE CONSENT
							</h1>
							<p
								className="fs-12 fw-500 text-start mt-4"
								style={{
									color: customDetails?.textColor,
									fontFamily: customDetails?.fontFamily,
									textAlign: 'left',
								}}
							>
								Enter your registered mobile number or AA handle to verify and
								manage your consents
							</p>
						</div>

						<div className="col-12">
							<label
								htmlFor="mobile-number"
								className="form-field-label"
								style={{
									color: customDetails?.textColor,
									fontFamily: customDetails?.fontFamily,
								}}
							>
								Mobile number
							</label>
							<div className="input-group mb-1" style={{ height: '50px' }}>
								<input
									id="mobile-number"
									type="tel"
									inputMode="numeric"
									autoComplete="tel"
									value={mobileNumber}
									onChange={(e) => onMobileNumberChange(e.target.value)}
									onKeyDown={(e) => {
										if (e.key === 'Enter' && !isGetOTPDisabled) {
											e.preventDefault();
											onSendOtp();
										}
									}}
									autoFocus
									className="form-control ps-3"
									aria-invalid={mobileError ? 'true' : undefined}
									aria-describedby={
										mobileError
											? 'login-mobile-hint mobile-number-error'
											: 'login-mobile-hint'
									}
									style={{
										fontFamily: customDetails?.fontFamily,
										width: '25%',
										display: 'block',
										marginLeft: 0,
										borderColor: mobileError ? '#c62828' : undefined,
									}}
								/>
							</div>
							<p id="login-mobile-hint" className="form-field-hint">
								OTP will be sent to your mobile number
							</p>
							{mobileError && (
								<p id="mobile-number-error" className="form-field-error" role="alert">
									{mobileError}
								</p>
							)}
						</div>

						<div className="col-12">
							<p
								style={{
									color: customDetails?.textColor,
									fontFamily: customDetails?.fontFamily,
								}}
							>
								OR
							</p>
						</div>

						<div className="col-12 mb-5">
							<label
								htmlFor="aa-handle"
								className="form-field-label"
								style={{
									color: customDetails?.textColor,
									fontFamily: customDetails?.fontFamily,
								}}
							>
								AA Handle
							</label>
							<div className="input-group mb-1" style={{ height: '50px' }}>
								<input
									id="aa-handle"
									type="text"
									autoComplete="username"
									value={AAHandle}
									onChange={(e) => onAAHandleChange(e.target.value)}
									onKeyDown={(e) => {
										if (e.key === 'Enter' && !isGetOTPDisabled) {
											e.preventDefault();
											onSendOtp();
										}
									}}
									className="form-control ps-3"
									aria-invalid={aaHandleError ? 'true' : undefined}
									aria-describedby={
										aaHandleError
											? 'aa-handle-suffix-text aa-handle-error'
											: 'aa-handle-suffix-text aa-handle-hint'
									}
									style={{
										fontFamily: customDetails?.fontFamily,
										paddingRight: '70px',
										borderColor: aaHandleError ? '#c62828' : undefined,
									}}
								/>
								<span id="aa-handle-suffix-text" className="input-fix-finvu" aria-hidden="true">@finvu</span>
							</div>
							<p id="aa-handle-hint" className="form-field-hint">
								Your handle ends with @finvu
							</p>
							{aaHandleError && (
								<p id="aa-handle-error" className="form-field-error" role="alert">
									{aaHandleError}
								</p>
							)}
						</div>

						<div className="col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-12 d-flex justify-content-center">
							<Button
								type="button"
								disabled={isGetOTPDisabled}
								onClick={onSendOtp}
								aria-busy={sendSpinner}
								aria-label={sendSpinner ? 'Sending OTP' : 'Get OTP'}
								color={customDetails?.primaryBtnColor}
								fontFamily={customDetails?.fontFamily}
								fontSize={customDetails?.fontSize}
								size="medium"
								padding="default"
								style={{
									height: customDetails?.btnHeight,
									width: customDetails?.btnWidth,
									borderRadius: customDetails?.borderRadius,
									opacity: 1,
								}}
								className="float-end fs-16 fw-600"
							>
								{sendSpinner ? (
									<div
										className="snippet"
										style={{ display: 'flex', justifyContent: 'center' }}
										data-title=".dot-pulse"
										aria-hidden="true"
									>
										<div className="stage">
											<div className="dot-pulse-btn"></div>
										</div>
									</div>
								) : (
									'Get OTP'
								)}
							</Button>
						</div>
					</div>
				</div>
			</div>

			<div className="col">
				<div className="col-lg-6 offset-lg-3 col-12">
					<p
						className="fs-12 fw-600"
						style={{
							color: customDetails?.textColor,
							bottom: '0px',
							fontFamily: customDetails?.fontFamily,
						}}
					>
						By proceeding you agree to Finvu's
						<br />
						<span style={{ display: 'inline-flex', alignItems: 'baseline', flexWrap: 'wrap' }}>
							<button
								disabled={sendSpinner}
								className="btn btn-link"
								onClick={onToggleSheet}
								style={{
									fontFamily: customDetails?.fontFamily,
									color: LINK_COLOR,
									fontSize: customDetails?.fontSize,
									padding: '0',
									textDecoration: 'underline',
									border: 'none',
									background: 'none'
								}}
							>
								Terms and Conditions
							</button>
							<span style={{ 
								margin: '0 6px', 
								color: customDetails?.textColor,
								fontSize: customDetails?.fontSize,
								fontFamily: customDetails?.fontFamily
							}}>
								&
							</span>
							<button
								disabled={sendSpinner}
								className="btn btn-link"
								onClick={onTogglePrivacySheet}
								style={{
									fontFamily: customDetails?.fontFamily,
									color: LINK_COLOR,
									fontSize: customDetails?.fontSize,
									padding: '0',
									textDecoration: 'underline',
									border: 'none',
									background: 'none'
								}}
							>
								Privacy Policy
							</button>
						</span>
					</p>
				</div>
			</div>
		</div>
	);
};

export default LoginForm;
